import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../Pages/Home/Home";
import Upcoming from "../Pages/Construction/Upcoming";
import InterriorSection from "../Pages/Interior Design/InterriorSection";

const PageRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/construction" element={<Upcoming />} />
        <Route path="/interior-design" element={<InterriorSection />} />
      </Routes>
    </Router>
  );
};

export default PageRoutes;
